import * as z from "zod";

export const ReceivingInspectionValidationSchema = z.object({
  isReceivingInspectionEnabled: z.boolean(),
  isDeviationConfirmationEnabled: z.boolean(),
});

export type ReceivingInspectionFormInput = z.infer<typeof ReceivingInspectionValidationSchema>;
